export default {
    courseIds: [568749, 554121, 471204],
    courseCount: 3
};
